import React, { memo, useEffect, useState } from "react"
import Link from "next/link"
import { Swiper, SwiperSlide } from "swiper/react"
import { Navigation } from "swiper"
import CardHorizontal from "components/TypeCard/CardHorizontal"

// eslint-disable-next-line react/display-name
const MySwiper = memo(({ name, videos, nextLink, isTopic }) => {
  const [deVice, setDeVice] = useState("desktop")
  const [isMobile, setIsMobile] = useState(false)

  const [data, setData] = useState([])

  useEffect(() => {
    function handleResize() {
      if (window.innerWidth < 640) {
        setIsMobile(true)
      } else {
        setIsMobile(false)
      }
    }

    handleResize()

    window.addEventListener("resize", handleResize)

    return () => window.removeEventListener("resize", handleResize)
  }, [])

  useEffect(() => {
    if (videos && videos.length > 0) {
      setData([videos[0]])
    }
  }, [videos])

  function onChangePerView() {
    if (deVice === "mobile") {
      return 1.8
    } else if (deVice === "ipad") {
      return 3.25
    } else {
      return 4.1
    }
  }

  function onChangePerGroup() {
    if (deVice === "mobile") {
      return 1
    } else if (deVice === "ipad") {
      return 3
    } else {
      return 4
    }
  }
  useEffect(() => {
    if (window.innerWidth < 768) {
      setDeVice("mobile")
    } else if (window.innerWidth >= 768 && window.innerWidth < 980) {
      setDeVice("ipad")
    } else {
      setDeVice("desktop")
    }
  })
  return (
    <div className="">
      <div>
        <h2 className="relative text-xl leading-6 font-semibold mt-2">
          <div className="w-full flex items-center wapper_see_more justify-between max-lg:mr-4 mr-8">
            <span className="text-[24px] leading-[30px] text-white font-semibold max-sm:text-[16px]">{name}</span>
            <div
              className={`text-primary text-sm sm:text-base md:text-xl font-extrabold whitespace-nowrap leading-[30px] flex items-center gap-[10px] ${
                !isMobile ? "" : ""
              }`}
            >
              {nextLink && (
                <Link href={nextLink}>
                  <span className="text-sm font-normal">Xem thêm</span>
                </Link>
              )}
            </div>
          </div>
        </h2>
        {isMobile && !isTopic ? (
          <div className="mb-6 max-sm:grid max-sm:gap-6">
            {data?.length > 0 &&
              data?.map((item) => {
                const { id, type } = item
                return (
                  <CardHorizontal
                    key={id}
                    {...item}
                    display_type={0}
                    nextLink={`/video?id=${id}&type=${type}`}
                    customGrid={true}
                  />
                )
              })}
            {data.length < videos.length ? (
              <div
                className="flex justify-center bg-[#2e2e2e] rounded-xl px-5 py-2"
                onClick={() => {
                  const currentLength = data.length
                  const additionalItems = videos.slice(currentLength, currentLength + 15)
                  setData([...data, ...additionalItems])
                }}
              >
                <span className="text-sm font-normal">Tải thêm</span>
              </div>
            ) : null}
          </div>
        ) : (
          <div className="relative wapper__swiper__custom">
            <Swiper
              key={"vod"}
              slidesPerView={isMobile && isTopic ? 1.5 : 4}
              slidesPerGroup={isMobile && isTopic ? 1.5 : 4}
              // slidesPerView={onChangePerView()}
              // slidesPerGroup={onChangePerGroup()}
              spaceBetween={24}
              modules={[Navigation]}
              className="swiper_card_horizontal"
              navigation={true}
              breakpoints={{
                0: {
                  slidesPerView: 2.5,
                  slidesPerGroup: 2,
                  spaceBetween: 12
                },
                900: {
                  slidesPerView: 2.7,
                  slidesPerGroup: 2
                },
                1070: {
                  slidesPerView: 2.9,
                  slidesPerGroup: 3
                },
                1280: {
                  slidesPerView: 3.1,
                  slidesPerGroup: 3
                },
                1536: {
                  slidesPerView: 3.3,
                  slidesPerGroup: 3
                },
                1700: {
                  slidesPerView: 3.5,
                  slidesPerGroup: 3
                }
              }}
            >
              {videos?.length > 0 &&
                videos?.map((item) => {
                  const { id, type } = item
                  return (
                    <SwiperSlide key={id}>
                      <CardHorizontal {...item} display_type={0} nextLink={`/video?id=${id}&type=${type}`} />
                    </SwiperSlide>
                  )
                })}
            </Swiper>
          </div>
        )}
      </div>
    </div>
  )
})

export default MySwiper
